import { Box } from '@mui/material';
import React from 'react';
import {
  TypedUseSelectorHook,
  useSelector as useReduxSelector,
} from 'react-redux';
import { RootState } from '../../../app/rootReducer';
import { ApplicationDetailedLifecycle } from '../../../common/components/ApplicationDetailedLifecycle';
import { ApplicationStageV2 } from '../../../common/components/ApplicationStageV2';
import { FlexRow, TitleMedium } from '../../../common/components/v2';
import ElementLocators from '../../../common/ElementLocators';
import styles from './styles.module.scss';

export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;
export const DetailsHeader = () => {
  const application = useSelector(state => state.application);
  const isAudit = useSelector(state => state.application.isAudit);
  const experimentName =
    useSelector(state => state.application.experimentName) || 'N/A';

  const { applicationDetailedLifecycle, applicationStageV2 } = application;

  const renderPillV2 = (
    <>
      {applicationDetailedLifecycle && (
        <ApplicationDetailedLifecycle
          detailedLifecycle={applicationDetailedLifecycle}
        />
      )}
      <ApplicationStageV2 stage={applicationStageV2} />
    </>
  );

  return (
    <FlexRow
      className={styles.Name}
      data-label={ElementLocators.LOCATOR_DETAILS_HEADER_SECTION}
    >
      <TitleMedium>
        {application.customerName}
        {isAudit && (
          <span
            className={styles.ExperimentTag}
          >{`( Experiment: ${experimentName} )`}</span>
        )}
      </TitleMedium>
      <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
        {renderPillV2}
      </Box>
    </FlexRow>
  );
};
